module.exports = __webpack_public_path__ + "static/media/Stoeberkurs_01.76f8573b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Stoeberkurs_01.jpg
// module id = 382
// module chunks = 0